import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/products";

export default function FloatingWhatsApp() {
  return (
    <a
      href={`https://wa.me/${COMPANY.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#1faa53] text-white flex items-center justify-center shadow-lg shadow-[#1faa53]/30 hover:scale-105 transition-transform"
    >
      <MessageCircle className="w-6 h-6" fill="currentColor" />
    </a>
  );
}
